export default __webpack_public_path__ + "static/media/washingtonstate.2f6cd457.png";